import { TeamAccessDTO } from '../team/team-access.dto';

export class ProductCheckpointListDTO extends TeamAccessDTO {

    id: string;

    title: string;

    description: string;
    
}
